<template>
    <div>
        <van-overlay :show="show" @click="show = false" >
            <div style="display: flex; justify-content:end">
                <img style="width: 300px ;  padding-right:10px;" src="../../assets/image/weixinDiaolog.png" >
            </div>
        </van-overlay>
        <div style=" margin-top: 120px;  display: flex; justify-content: center; align-items: center;"><img style="width: 120px;    border-radius: 18px;" src="../../assets/image/appLog.png"></div>

        <div style="margin-top: 40px; text-align: center; font-size: 18px; font-weight: 500;">巴斯夫调漆宝</div>
   
        <div style="margin-top: 150px;  display: flex; align-items: center; justify-content: center;"><van-button style="width: 90%; border-radius: 10px;"  color="#1989fa"  :loading=" loading" @click="openClient()"  > 打开客户端</van-button></div>
        <div v-if="systemType === 'iOS'"  style="margin-top: 20px;  display: flex; align-items: center; justify-content: center;" ><van-button style="width: 90%; border-radius: 10px; color:#1989fa "  :icon="require('../../assets/image/ios.png')" @click="download(1)" >App Store</van-button></div>
        <div v-else style="margin-top: 20px;  display: flex; align-items: center; justify-content: center;"><van-button style="width: 90%; border-radius: 10px; color:#1989fa "  :icon="require('../../assets/image/android.png')" @click="download(2)" >安卓版下载</van-button></div>
   
    </div>

</template>

<script>

import Api from "../../api/api";
import { Toast } from 'vant';
 export default {
    data() {
      return {
        iosUrl: '', //
        androidUrl:'',
        show:false,
        systemType: '', // 系统类型
        loading: false,

      }
    },

    created() {
   
        this.getappList();
  },

  mounted() {
        this.detectSystem();
    },

  methods: {

    detectSystem() {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // 判断是否为 iOS
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                this.systemType = 'iOS';
            }
            // 判断是否为 Android
            else if (/android/i.test(userAgent)) {
                this.systemType = 'Android';
            }
            // 其他系统
            else {
                this.systemType = '其他';
            }
        },

    getappList(){
        Api.getAppList().then((res) => {
            if (res.data.code == 0) {
                let list= res.data.result
                    for (let i = 0; i < list.length; i++) {
                            let obj=list[i]
                            if(obj.appName=='basf_recipe_ios'){
                                this.iosUrl=obj.updateUrl
                            }else if (obj.appName=='basf_recipe_android'){
                                 this.androidUrl=obj.updateUrl
                            }
                    }

            }
          })


    },

    openClient(){
        var u = navigator.userAgent;
        var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内

          // 微信内
          if(isWeixin) {
            this.show=true 
            return ;       
         }
         this.loading = true;
         console.log("环境：", process.env.NODE_ENV);
        const url = process.env.NODE_ENV === 'production' ? "holimobile://prod" : "holimobile://test";
        console.log("url：", url);
          // 尝试打开应用
         const start = Date.now();
         window.location.href = url;
       
          // 超时检测
      setTimeout(() => {
     
        if (Date.now() - start < 2000) {
          // 如果在2秒内返回，说明没有成功打开应用
          this.loading = false;
          Toast.fail('未安装APP，请先下载'); // 提示用户下载
        }
      }, 1500);

           
        
         
    },

    download(type){
        var u = navigator.userAgent;
        var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
          // 微信内
          if(isWeixin) {
            this.show=true 
            return ;
                    
         }
        if(type==1){
            window.location.href =this.iosUrl;
        }else{
          window.location.href =this.androidUrl;
        }

    }

  }

}
</script>

